import React, { useEffect, useState } from 'react';
import { AsideDefault } from '../components/aside/AsideDefault';
import { HeaderWrapper } from '../components/header/HeaderWrapper';
import { Content } from '../components/Content';
import { PageDataProvider } from './core';
import { useLocation } from 'react-router-dom';
import { MenuComponent } from '../../_flexCharge/assets/ts/components';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../setup';
import { ADMIN_GROUPS } from '../views/login/Login';
import * as auth from '../redux/AuthRedux';
import { IAuthState } from '../redux/AuthRedux';
import { Logout } from '../components/auth';
import { useMerchants } from '../store/merchnts/merchants-context';
import clsx from 'clsx';
import { fetchWebhookEventType } from '../store/merchnts/actions/webhooks';
import { fetchPartnersListNames } from '../store/merchnts/actions/partners';
import { fetchMerchantsLists } from '../store/merchnts/actions/merchant';
import { Spinner } from '../components/Spinner';
import { useOrdersContext } from '../store/order/order-context';
import { fetchAccountList } from '../store/merchnts/actions/account';
import { LoginLayout } from './core/LoginLayout';
import { MfaLayout } from './core/MfaLayout';
import { setPlatformSystem } from '../store/merchnts/actions/security';
import { checkRoles, CLAIMS } from '../utils/roles-helper';
import {
	getFavoriteFiltersFromStorage,
	getFiltersFromStorage,
	removeFilters,
} from '../utils/filter-helpers';
import { setOrderFavoriteFilters } from '../store/order/actions/order';

const MasterLayout = ({ children }: any): React.ReactElement => {
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const dispatch = useDispatch();
	const { dispatch: orderDispatch } = useOrdersContext();
	const { merchantState: { merchantData, isGlobalTransparentLoader }, dispatch: merchantDispatch } = useMerchants();
	const isMerchantPage = location.pathname?.includes(merchantData?.id);
	const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
	const isAdmin = authUser?.userData?.userGroups?.some(el => el === ADMIN_GROUPS.SUPER_ADMIN);

	const [isAlertLabel, setIsAlertLabel] = useState<boolean>(false);
	const savedOrderFavoriteFilters: string[] = getFavoriteFiltersFromStorage('orders');
	const localStorageFilters = JSON.parse(getFiltersFromStorage());

	useEffect(() => {
		const handleStorageChange = (event): void => {
			if (event.key === 'loginData') {
				const localData = JSON.parse(event.newValue);
				dispatch(auth.actions.login(localData));
			}
		};

		window.addEventListener('storage', handleStorageChange);
	}, []);

	const path = location.pathname.split('/')[1];

	useEffect(() => {
		if (path !== 'orders') {
			localStorage.removeItem('savedOrderVisibilityState');
		}

		if (!location.pathname.split('/').includes('applications')) {
			localStorage.removeItem('applicationsPageData');
		}

	}, [path]);

	useEffect(() => {
		const pathNames = ['orders', 'applications'];
		pathNames.forEach((pathName) => {
			if (!location.pathname.includes(pathName) && localStorageFilters?.[pathName]) {
				removeFilters(pathName);
			}
		});
	}, [path]);

	useEffect(() => {
		if (savedOrderFavoriteFilters?.length) {
			setOrderFavoriteFilters(orderDispatch, savedOrderFavoriteFilters);
		}
	}, []);

	// useEffect(() => {
	// 	// TODO check partners permissions
	// 	if (!isAdmin && !isPartnerAdmin && !isIntegrationPartner) {
	// 		void fetchMerchantData(merchantDispatch, applicationId);
	// 	}
	// }, []);

	useEffect(() => {
		setTimeout(() => {
			MenuComponent.reinitialization();
		}, 500);
	}, []);
	useEffect(() => {
		if (searchParams.has('isGhostMode') || (isMerchantPage && merchantData?.status === 2)) {
			setIsAlertLabel(true);
		} else {
			setIsAlertLabel(false);
		}
	}, [location.pathname, merchantData]);

	useEffect(() => {
		fetchMerchantsLists(merchantDispatch);
		const platform = navigator.platform.toLowerCase();
		setPlatformSystem(merchantDispatch, platform);
	}, []);

	useEffect(() => {
		checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN) && fetchAccountList(merchantDispatch);
	}, []);

	useEffect(() => {
		checkRoles(authUser, CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN) && fetchWebhookEventType(merchantDispatch);
	}, []);

	useEffect(() => {
		isAdmin && fetchPartnersListNames(merchantDispatch);
	}, []);

	useEffect(() => {
		setTimeout(() => {
			MenuComponent.reinitialization();
		}, 500);
	}, [location.key]);

	if (!authUser.userData) {
		return (
			<Logout />
		);
	}

	if (location.pathname === '/auth/login'
		|| location.pathname === '/agreements/merchant-factoring-agreement'
	) {
		// @ts-ignore
		return <Content>{children}</Content>;
	}

	if (location.pathname === '/stripe-success'
		|| location.pathname === '/stripe-decline'
	) {
		// @ts-ignore
		return <>{children}</>;
	}

	// TODO
	// if (authUser.userData?.applicationStatus && authUser.userData?.applicationStatus !== STATUSES.APPROVED && !isAdmin) {
	// 	return (
	// 		<Routes>
	// 			<Route path='*' element={<Navigate to={'/auth/confirm-application'} state={{ id: applicationId }} />} />
	// 		</Routes>
	// 	);
	// }

	const getAlertLabelText = (): string => {
		if (searchParams.has('isGhostMode')) {
			return 'Ghost mode order';
		}
		if (isMerchantPage && merchantData?.status === 2) {
			return 'Merchant is not Active';
		}
	};

	return (
		<PageDataProvider>
			<div className="page d-flex flex-row flex-column-fluid">
				{isGlobalTransparentLoader && <Spinner pageLoader globalTransparentLoader/>}
				<AsideDefault/>
				<div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
					<HeaderWrapper/>

					<div id="kt_content" className="content d-flex flex-column flex-column-fluid">
						{/*<Toolbar/>*/}
						<div
							className={clsx('post d-flex flex-column-fluid position-relative', isAlertLabel && 'pt-7')}
							id="kt_post"
						>
							{
								isAlertLabel && (
									<div className="position-absolute py-2 fw-bolder fs-6 ghost-alert w-100">
										<div className="text-center">
										 	{getAlertLabelText()}
										</div>
									</div>
								)
							}
							{/*@ts-ignore*/}
							<Content>{children}</Content>
						</div>
					</div>
					{/*<Footer/>*/}
				</div>
				<LoginLayout/>
				<MfaLayout/>
			</div>

			{/* begin:: Drawers */}
			{/*<ActivityDrawer/>*/}
			{/*<ExploreMain/>*/}
			{/*<DrawerMessenger/>*/}
			{/* end:: Drawers */}

			{/* begin:: Modals */}
			{/*<Main/>*/}
			{/*<InviteUsers/>*/}
			{/*<UpgradePlan/>*/}
			{/* end:: Modals */}
			{/*<ScrollTop/>*/}
		</PageDataProvider>
	);
};

export { MasterLayout };
